import React from 'react'
import PropTypes from 'prop-types'

import {
  Button, Form, SidebarModal,
} from '@domain-group/suit-theme'

import usePaymentMethod, { usePaymentMethodForm } from '@hooks/usePaymentMethod'

const CreatePaymentMethodModal = (props) => {
  const { callbacks, modalKey, showModal } = props
  const { closeModal, createPaymentMethod } = callbacks

  const {
    callbacks: {
      createPaymentMethod: createFn,
    },
    creating,
  } = usePaymentMethod()

  const {
    entityState,
    entityState: {
      short_name,
      title,
    },
    errors,
    handlers,
    saveEnabled,
  } = usePaymentMethodForm({}, { validateOn: 'change' })

  const createPaymentMethodPayload = {
    callbacks: {
      action: createFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    toastText: 'Payment Method Created',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title="Create" titleSecondLine="Payment Method" />

      <SidebarModal.Content>
        <Form>
          <Form.Field errorMessage={errors.title} label="* Title">
            <input name="title" value={title} type="text" {...handlers} />
          </Form.Field>

          <Form.Field errorMessage={errors.short_name} label="* Short Name" marginTop="large">
            <input name="short_name" value={short_name} type="text" {...handlers} />
          </Form.Field>
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={creating}
          onClick={() => createPaymentMethod(createPaymentMethodPayload)}
          size="large"
        >
          {saveEnabled ? 'Create Payment Method' : 'Complete Fields'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

CreatePaymentMethodModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

CreatePaymentMethodModal.defaultProps = {
  modalKey: 'CreatePaymentMethodModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <CreatePaymentMethodModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
